export const STORY_TITLE_MIN_LENGTH = 1;
export const STORY_TITLE_MAX_LENGTH = 120;
export const STORY_SYNOPSIS_MAX_LENGTH = 500;
export const GENRE_SELECTION_MIN = 3;
export const DECISION_QUESTION_MAX_LENGTH = 200;
export const CHOICE_LABEL_MAX_LENGTH = 80;
export const CHOICE_SUBTITLE_MAX_LENGTH = 140;
export const ENDING_NAME_MAX_LENGTH = 80;
export const COMMENT_TEXT_MAX_LENGTH = 500;
export const DISPLAY_NAME_MIN_LENGTH = 2;
export const DISPLAY_NAME_MAX_LENGTH = 40;
export const BIBLE_TONE_MAX_LENGTH = 300;
export const BIBLE_SETTING_MAX_LENGTH = 1000;
export const BIBLE_NOTES_MAX_LENGTH = 500;
export const CHARACTER_NAME_MAX_LENGTH = 80;
export const CHARACTER_DESCRIPTION_MAX_LENGTH = 1000;
export const LOCATION_NAME_MAX_LENGTH = 80;
export const LOCATION_DESCRIPTION_MAX_LENGTH = 1000;
export const NODE_TITLE_MAX_LENGTH = 120;
export const SHOT_PURPOSE_MAX_LENGTH = 200;
export const SHOT_ACTION_MAX_LENGTH = 1000;
export const SHOT_VOICEOVER_MAX_LENGTH = 500;
export const FLAG_NAME_MAX_LENGTH = 60;
export const BRIEF_MIN_LENGTH = 10;
export const BRIEF_MAX_LENGTH = 2000;
